import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
/*
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/


@Injectable()
class FeedService {
    constructor() {
    }
    
    public getFeeds () {
        let feeds = [
                {category:'social',list:[{title:'s1',subtitle:'s1sub'}, {title:'s2',subtitle:'s2sub'},{title:'s3',subtitle:'s3sub'}]},
                {category:'news',list:[{title:'n1',subtitle:'n1sub'}, {title:'n2',subtitle:'n2sub'},{title:'n3',subtitle:'n3sub'}]},
                {category:'travel',list:[{title:'t1',subtitle:'t1sub'}, {title:'t2',subtitle:'t2sub'},{title:'t3',subtitle:'t3sub'}]},
                ];
        return feeds;
    }
}

/*
    Service class should be exported as ExportedClass
*/
export { FeedService as ExportedClass };
